import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import ArticlePage from "@/pages/ArticlePage";
import PrivacyPage from "@/pages/PrivacyPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminArticleEditor from "@/pages/AdminArticleEditor";
import LocationPage, { CITIES } from "@/pages/LocationPage";
import GuidePage, { GUIDES } from "@/pages/GuidePage";
import CalculatorPage from "@/pages/CalculatorPage";
import RiskAssessmentPage from "@/pages/RiskAssessmentPage";
import HRPortfolio from "@/pages/HRPortfolio";
import HRClientDashboard from "@/pages/HRClientDashboard";
import HRCalendar from "@/pages/HRCalendar";
import HRReports from "@/pages/HRReports";
import ProtectedRoute from "@/components/ProtectedRoute";
import CookieBanner from "@/components/CookieBanner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import { AuthProvider } from "@/lib/auth";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <AuthProvider>
                    <AnalyticsTracker />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/articolo/:slug" element={<ArticlePage />} />
                        <Route path="/privacy" element={<PrivacyPage />} />
                        <Route path="/avvocato-lavoro-piacenza" element={<LocationPage city={CITIES.piacenza} />} />
                        <Route path="/avvocato-lavoro-milano" element={<LocationPage city={CITIES.milano} />} />
                        <Route path="/avvocato-lavoro-lecce" element={<LocationPage city={CITIES.lecce} />} />
                        <Route path="/avvocato-lavoro-cremona" element={<LocationPage city={CITIES.cremona} />} />
                        <Route path="/avvocato-lavoro-pavia" element={<LocationPage city={CITIES.pavia} />} />
                        <Route path="/avvocato-lavoro-lodi" element={<LocationPage city={CITIES.lodi} />} />
                        <Route path="/avvocato-lavoro-fidenza" element={<LocationPage city={CITIES.fidenza} />} />
                        <Route path="/avvocato-lavoro-fiorenzuola-darda" element={<LocationPage city={CITIES["fiorenzuola-darda"]} />} />
                        <Route path="/guide/avvocato-licenziamento-piacenza" element={<GuidePage guide={GUIDES.licenziamentoPiacenza} />} />
                        <Route path="/guide/avvocato-mobbing-piacenza" element={<GuidePage guide={GUIDES.mobbingPiacenza} />} />
                        <Route path="/guide/calcolo-naspi-2026" element={<GuidePage guide={GUIDES.calcoloNaspi} />} />
                        <Route path="/calcolo-termini-impugnazione-licenziamento" element={<CalculatorPage />} />
                        <Route path="/valutatore-rischio-licenziamento" element={<RiskAssessmentPage />} />
                        <Route path="/admin/login" element={<AdminLoginPage />} />
                        <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
                        <Route path="/admin/articoli/:id" element={<ProtectedRoute><AdminArticleEditor /></ProtectedRoute>} />
                        <Route path="/admin/hr" element={<ProtectedRoute><HRPortfolio /></ProtectedRoute>} />
                        <Route path="/admin/hr/calendario" element={<ProtectedRoute><HRCalendar /></ProtectedRoute>} />
                        <Route path="/admin/hr/report" element={<ProtectedRoute><HRReports /></ProtectedRoute>} />
                        <Route path="/admin/hr/clients/:id" element={<ProtectedRoute><HRClientDashboard /></ProtectedRoute>} />
                    </Routes>
                    <CookieBanner />
                </AuthProvider>
            </BrowserRouter>
        </div>
    );
}

export default App;
